import PostCard from "../cards/PostCard";
import { posts } from "../../data/posts";
import "../../styles/featured-posts.css";

const FeaturedPosts = () => {
  const featuredPosts = posts.slice(0, 4);

  return (
    <section className="featured-posts">
      <div className="featured-posts__header">
        <span className="featured-posts__eyebrow">Selected Writings</span>
        <h2>Featured entries from across the archive.</h2>
      </div>

      <div className="featured-posts__grid">
        {featuredPosts.map((post) => (
          <PostCard key={post.slug} post={post} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedPosts;